export type RuntimeMode = "production" | "sandbox" | "mock";

const configuredMode = import.meta.env.VITE_APP_MODE;
const configuredIntegrationMode: unknown = import.meta.env.VITE_INTEGRATION_MODE;

export const RUNTIME_MODE: RuntimeMode =
  configuredMode === "production" || configuredMode === "mock" || configuredMode === "sandbox"
    ? configuredMode
    : "sandbox";

export const IS_SANDBOX = RUNTIME_MODE !== "production";
export const INTEGRATIONS_SIMULATED =
  (typeof configuredIntegrationMode === "string" ? configuredIntegrationMode : "mock").toLowerCase() !==
  "live";

// 空值表示使用当前站点同源 API，避免生产包依赖开发机地址。
export const API_BASE_URL = (import.meta.env.VITE_CAUTI_API_URL ?? "").replace(/\/+$/, "");

export const REQUEST_TIMEOUT_MS = Number(import.meta.env.VITE_API_TIMEOUT_MS ?? 15_000);
